import { useForm } from "react-hook-form";
import useFormField from "../hooks/useFormField";
import TextInput from "../ui/TextInput";
import React from "react";
import AlbumSearchDropdown from "./AlbumSearchDropdown";
import ArtistSearchDropdown from "./ArtistSearchDropdown";
import TrackSearchDropdown from "./TrackSearchDropdown";
import UserSearchDropdown from "./UserSearchDropdown";
const INITIAL_CONTEXT = {
  albumId: null,
  artistId: null,
  trackId: null,
  input: "",
  userIds: [],
};
function AdminOpInputs({ op, onContextChange, resetToken }) {
  const form = useForm({
    defaultValues: {
      albumId: INITIAL_CONTEXT.albumId,
      albumText: "",
      artistId: INITIAL_CONTEXT.artistId,
      artistText: "",
      trackId: INITIAL_CONTEXT.trackId,
      trackText: "",
      input: INITIAL_CONTEXT.input,
      userIds: INITIAL_CONTEXT.userIds,
    },
    mode: "onChange",
  });
  const [albumId, setAlbumId] = useFormField(form, "albumId");
  const [albumText, setAlbumText] = useFormField(form, "albumText");
  const [artistId, setArtistId] = useFormField(form, "artistId");
  const [artistText, setArtistText] = useFormField(form, "artistText");
  const [trackId, setTrackId] = useFormField(form, "trackId");
  const [trackText, setTrackText] = useFormField(form, "trackText");
  const [input, setInput] = useFormField(form, "input");
  const [userIds, setUserIds] = useFormField(form, "userIds");
  React.useEffect(() => {
    onContextChange?.({
      albumId,
      artistId,
      trackId,
      input,
      userIds,
    });
  }, [albumId, artistId, trackId, input, userIds, onContextChange]);
  React.useEffect(() => {
    setAlbumId(INITIAL_CONTEXT.albumId);
    setAlbumText("");
    setArtistId(INITIAL_CONTEXT.artistId);
    setArtistText("");
    setTrackId(INITIAL_CONTEXT.trackId);
    setTrackText("");
    setInput(INITIAL_CONTEXT.input);
    setUserIds([]);
  }, [
    resetToken,
    op.key,
    setAlbumId,
    setAlbumText,
    setArtistId,
    setArtistText,
    setTrackId,
    setTrackText,
    setInput,
    setUserIds,
  ]);
  const dropdownKey = `${op.key}-${resetToken}`;
  return (
    <div className="admin-inputs">
      {op.needsAlbum && (
        <AlbumSearchDropdown
          admin
          value={albumText}
          onChange={(val) => {
            setAlbumText(val);
            setAlbumId(null);
          }}
          onSelect={(album) => setAlbumId(album.id)}
        />
      )}
      {op.needsArtist && (
        <ArtistSearchDropdown
          admin
          value={artistText}
          onChange={(val) => {
            setArtistText(val);
            setArtistId(null);
          }}
          onSelect={(artist) => setArtistId(artist.id)}
        />
      )}
      {op.needsTrack && (
        <TrackSearchDropdown
          admin
          value={trackText}
          onChange={(val) => {
            setTrackText(val);
            setTrackId(null);
          }}
          onSelect={(trackIdValue) => setTrackId(trackIdValue)}
        />
      )}
      {op.needsUser && (
        <UserSearchDropdown
          key={dropdownKey}
          onAdd={(user) =>
            setUserIds((prev) =>
              prev.includes(user.discogs_id)
                ? prev
                : [...prev, user.discogs_id],
            )
          }
          onRemove={(id) => setUserIds((prev) => prev.filter((x) => x !== id))}
        />
      )}
      {op.needsId && (
        <TextInput
          type="number"
          aria-label="Resource ID"
          placeholder="ID"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      )}
    </div>
  );
}
export default AdminOpInputs;
